import { React, serviceClient, dtos, observer, shared, observable, ui, _, Link, Observer, moment, selectFilter, splitIntoWords, makeObservable } from "../common";
import ValueEditor from "../flows/value-editor";
import AccountHeader from "../account-header";
import AutoFocus from "../autofocus";
import { KeyboardEvent } from "react";
import PageTitle from "../page-title";
import NewAlert from "./new";
import AutoComplete from "../autocomplete";
import AlertDetails from "./details"

@observer
export default class AlertIndex extends React.Component {
    @observable alerts: Array<dtos.AlertInfo> = [];
    @observable pagination: any = { position: "both" };
    @observable filter: any = {};
    @observable sort: any = {};
    @observable loading = true;
    @observable pageSize = 20;
    @observable selectedAlertIds: Array<string> = [];
    @observable showNewAlert = false;
    @observable editId = "";

    constructor(props) {
        super(props);
        makeObservable(this);
        this.filter.name = localStorage.getItem("AlertIndex.filter.name");
        this.filter.customerId = localStorage.getItem("AlertIndex.filter.customerId");
        this.filter.shallowParent = localStorage.getItem("AlertIndex.filter.shallowParent") == "true";
        this.pageSize = parseInt(localStorage.getItem("AlertIndex.pagination.pageSize") || "20");
    }

    async componentDidMount() {
        this.refresh(1);
    }

    async refresh(page = this.pagination.page || 1, sort = this.sort) {
        this.loading = true;
        let request = new dtos.ListAlerts({
            accountIds: [shared.accountId],
            countPerPage: this.pageSize,
            page: page - 1,
            sortField: sort.field,
            sortOrder: sort.order,
            nameFilter: this.filter.name || null,
            simplifiedPaging: true,
        });
        let response = await serviceClient.get(request);
        let currentlySelected = this.alerts.filter(ep => this.selectedAlertIds.indexOf(ep.id) >= 0);
        this.alerts = [...currentlySelected, ...response.items.filter(c => this.selectedAlertIds.indexOf(c.id) < 0)];
        let pager = { ...this.pagination };
        pager.current = page;
        pager.total = page * this.pageSize + (response.hasMorePages ? 1 : 0);
        pager.pageSize = this.pageSize;
        pager.showSizeChanger = true;
        pager.pageSizeOptions = ["10", "20", "50", "100", "250"];
        pager.onShowSizeChange = (c, v) => this.pageSize = v;

        this.pagination = pager;
        this.loading = false;

        localStorage.setItem("AlertIndex.filter.name", this.filter.name || "");
        localStorage.setItem("AlertIndex.filter.shallowParent", this.filter.shallowParent ? "true" : "false");
        localStorage.setItem("AlertIndex.filter.customerId", this.filter.customerId || "");
        localStorage.setItem("AlertIndex.pagination.pageSize", this.pageSize.toString());
    }

    checkFilterSubmit(ev: KeyboardEvent) {
        if (ev.which == 13) {
            this.refresh();
        }
    }

    async deleteAlert(alert: dtos.AlertInfo) {
        await serviceClient.delete(new dtos.DeleteAlert({
            alertId: alert.id
        }));
        let idx = this.alerts.indexOf(alert);
        this.alerts.splice(idx, 1);
        this.forceUpdate();
        ui.message.info(alert.name + " deleted");
    }

    async deleteAlerts() {
        this.loading = true;
        for (let alertId of this.selectedAlertIds) {
            await serviceClient.delete(new dtos.DeleteAlert({ alertId: alertId }));
        }
        this.selectedAlertIds = [];
        this.refresh();
        this.loading = false;
    }

    onAlertCreated(alert: dtos.AlertInfo) {
        this.refresh();
        this.showNewAlert = false;
    }

    render() {
        const rowSelection = {
            selectedRowKeys: this.selectedAlertIds,
            onChange: keys => this.selectedAlertIds = keys
        };

        return (
            <div>
                <ui.Form layout="inline" style={{ marginBottom: 8 }}>
                    <ui.Form.Item>
                        <ui.Input onKeyPress={ev => this.checkFilterSubmit(ev)} placeholder="Filter by name" value={this.filter.name || ""} onChange={ev => this.filter.name = ev.target.value} />
                    </ui.Form.Item>

                    <ui.Form.Item>
                        <ui.Button.Group>
                            <ui.Button type="primary" onClick={() => this.refresh()}>Search</ui.Button>
                            <ui.Button type="default" onClick={() => { this.filter = {}; this.selectedAlertIds = []; this.refresh(); }}>Clear</ui.Button>
                        </ui.Button.Group>
                    </ui.Form.Item>
                </ui.Form>
                <ui.Table className="hide-pagination-buttons" rowSelection={rowSelection} loading={this.loading} dataSource={this.alerts} rowKey="id" pagination={this.pagination} onChange={(p, f, s) => this.refresh(p.current, s)}>
                    <ui.Table.Column dataIndex="name" title="Name" render={(text, rec: dtos.AlertInfo) => <>
                        <ui.Button type="link" onClick={() => this.editId = rec.id}>{rec.name}</ui.Button>
                    </>} />

                    <ui.Table.Column title="Trigger" dataIndex="trigger" render={(text, rec: dtos.AlertInfo) => splitIntoWords(rec.trigger)} />
                    <ui.Table.Column title="Threshold" dataIndex="threshold" />
                    <ui.Table.Column title="Window" dataIndex="windowHours" render={(text, rec: dtos.AlertInfo) => `${rec.windowHours} hours`} />
                    <ui.Table.Column title="Email" render={(text, rec:dtos.AlertInfo) => (rec.notificationEmailAddresses || "").split('\n').join(",")} />
                    <ui.Table.Column title="Last Modified" render={(text, rec: dtos.AlertInfo) => <span>{moment(rec.dateLastModified).format("LLLL")} by {rec.lastModifiedBy}</span>} />

                </ui.Table>

                <ui.Button.Group style={{ marginBottom: 16 }}>
                    <ui.Button type="primary" onClick={() => this.showNewAlert = true}>New Alert</ui.Button>
                    {this.selectedAlertIds.length > 0 && <ui.Popconfirm title="Are you sure you want to delete the selected integrations?" onConfirm={() => this.deleteAlerts()}><ui.Button danger>Delete Alerts</ui.Button></ui.Popconfirm>}
                </ui.Button.Group>

                <NewAlert visible={this.showNewAlert} onClosed={() => this.showNewAlert = false} onCreated={alert => this.onAlertCreated(alert)} />
                {this.editId && <AlertDetails id={this.editId} visible={true} onClosed={() => this.editId = ""} onSaved={() => this.refresh()} />}
            </div>

        );
    }
}